// extracted by mini-css-extract-plugin
export default {"popupBody":"AddressAlert_popupBody__VWYsF","closeBtn":"AddressAlert_closeBtn__t-JkG","callAlert":"AddressAlert_callAlert__HYrZ6"};